import { useState, useEffect } from 'react';
import { Search } from 'lucide-react';
import { Input } from '@/components/ui/input';
import { useFamilyStore } from '@/store/familyStore';
import { FamilyMember } from '@/types';
import { searchMembers } from '@/utils/family/search';

interface MemberSearchProps {
  selectedMember?: FamilyMember | null;
  onSelect: (memberId: string) => void;
  placeholder?: string;
}

export function MemberSearch({ selectedMember, onSelect, placeholder }: MemberSearchProps) {
  const [query, setQuery] = useState(selectedMember?.name || '');
  const [results, setResults] = useState<Array<{ member: FamilyMember; lineage: string }>>([]);
  const { members } = useFamilyStore();

  useEffect(() => {
    if (query.length >= 2 && !selectedMember) {
      const searchResults = searchMembers(query, members);
      setResults(searchResults);
    } else {
      setResults([]);
    }
  }, [query, members, selectedMember]);

  const handleSelect = (member: FamilyMember, lineage: string) => {
    setQuery(lineage);
    onSelect(member.id);
    setResults([]);
  };

  return (
    <div className="relative">
      <div className="relative">
        <Input
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          placeholder={placeholder || "ابحث عن شخص..."}
          className="pl-10"
        />
        <Search className="absolute left-3 top-3 h-4 w-4 text-gray-400" />
      </div>

      {results.length > 0 && !selectedMember && (
        <div className="absolute z-50 w-full mt-1 bg-white rounded-lg shadow-lg border max-h-48 overflow-y-auto">
          {results.map(({ member, lineage }) => (
            <button
              key={member.id}
              type="button"
              className="w-full text-right px-4 py-3 hover:bg-gray-50 border-b last:border-b-0"
              onClick={() => handleSelect(member, lineage)}
            >
              <div className="text-sm text-gray-500 mt-1">{lineage}</div>
            </button>
          ))}
        </div>
      )}

      {selectedMember && (
        <div className="mt-2 p-3 bg-gray-50 rounded-lg">
          <div className="font-medium">الشخص المحدد:</div>
          <div className="text-sm text-gray-600">{selectedMember.name}</div>
        </div>
      )}
    </div>
  );
}